export const UPLOAD_TRACK_REQUEST = 'UPLOAD_TRACK_REQUEST';
export const CLEAR_UPLOAD_REQUEST = 'CLEAR_UPLOAD_REQUEST';
export const UPLOAD_TRACK_SUCCESS = 'UPLOAD_TRACK_SUCCESS';
export const UPLOAD_TRACK_FAILURE = 'UPLOAD_TRACK_FAILURE';
export const GET_UPLOADS_REQUEST = 'GET_UPLOADS_REQUEST';
export const GET_UPLOADS_SUCCESS = 'GET_UPLOADS_SUCCESS';
export const GET_UPLOADS_FAILURE = 'GET_UPLOADS_FAILURE';
